export const useCommaAsDecimalPoint = (number: number) => number.toString().replace(/\./, ',')

export const insertThousandSeparator = (number: number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
